// extracted by mini-css-extract-plugin
export default {"button":"AddProductInCartButton_button__-X5mX"};